import React from 'react'
import { tokens, FontIcon } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'
import { useTranslation } from 'i18n'

type PasswordValidationProps = {
  password: string
}

const ValidationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
  margin-top: ${tokens.spacing.verticalXsmall};
  width: 100%;
`

const ValidationItem = styled.div<{ isValid: boolean }>`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.horizontalSmall};
  color: ${props =>
    props.isValid ? tokens.colors.success : tokens.colors.error};
  font-size: ${tokens.fontSize.small};
  transition: color 0.2s ease;
`

const ValidationIcon = styled(FontIcon)<{ isValid: boolean }>`
  color: ${props =>
    props.isValid ? tokens.colors.success : tokens.colors.error};
  font-size: 16px;
  flex-shrink: 0;
`

const validateLength = (password: string): boolean => {
  return password.length >= 5 && password.length <= 30
}

const validateHasLettersOrNumbers = (password: string): boolean => {
  return /[a-zA-Z0-9]/.test(password)
}

const validateSpecialCharacters = (password: string): boolean => {
  const allowedSpecialChars = /^[a-zA-Z0-9_!@#$%&*)]+$/
  return allowedSpecialChars.test(password)
}

const PasswordValidation: React.FC<PasswordValidationProps> = ({
  password
}) => {
  const { t } = useTranslation()
  const lengthValid = validateLength(password)
  const hasLettersOrNumbers = validateHasLettersOrNumbers(password)
  const specialCharsValid = validateSpecialCharacters(password)

  return (
    <ValidationContainer>
      <ValidationItem isValid={lengthValid}>
        <ValidationIcon
          isValid={lengthValid}
          iconName={lengthValid ? 'check-circle' : 'cancel-circle'}
          size={16}
        />
        <span>{t('5-30 caracteres')}</span>
      </ValidationItem>
      <ValidationItem isValid={hasLettersOrNumbers}>
        <ValidationIcon
          isValid={hasLettersOrNumbers}
          iconName={hasLettersOrNumbers ? 'check-circle' : 'cancel-circle'}
          size={16}
        />
        <span>{t('Contém letras ou números')}</span>
      </ValidationItem>
      <ValidationItem isValid={specialCharsValid}>
        <ValidationIcon
          isValid={specialCharsValid}
          iconName={specialCharsValid ? 'check-circle' : 'cancel-circle'}
          size={16}
        />
        <span>{t('Caracteres especiais aceitos: _!@#$%&*)')}</span>
      </ValidationItem>
    </ValidationContainer>
  )
}

export default PasswordValidation
